import { z } from "zod";

/**
 * A calendar day: `YYYY-MM-DD` (canon 06 §6.5.3), **the shape AND a real date, never a timestamp** , `2026-02-30` has the shape and
 * is no day, and `2026-09-21T00:00:00Z` is an instant, not a day. `C-5`'s `asOf` on `GET /api/v1/bank/files/{id}/offer` is one
 * (the AA to AD architect's condition A1): the door says what day it is, in Africa/Bamako, and the screen reads no clock of its own.
 */
export const CALENDAR_DAY_PATTERN = /^\d{4}-\d{2}-\d{2}$/u;

export function isCalendarDay(value: unknown): value is string {
  if (typeof value !== "string" || !CALENDAR_DAY_PATTERN.test(value)) return false;
  const [year, month, day] = value.split("-").map(Number);
  const at = new Date(Date.UTC(year ?? 0, (month ?? 0) - 1, day ?? 0));
  // The day must come back as written: a 30th of February rolls over into March, and that is the refusal.
  return at.getUTCFullYear() === year && at.getUTCMonth() === (month ?? 0) - 1 && at.getUTCDate() === day;
}

export const calendarDaySchema = z.string().refine(isCalendarDay, { message: "a calendar day, YYYY-MM-DD" });
